import { getConfig } from '@config/index'

import { IconSprites } from '@constants/enums/sprites'

import { type NavLinkItem } from '@components/ui-core/types'

const config = getConfig()

export const footerContent: NavLinkItem[] = [
  {
    label: 'Products',
    links: [
      {
        label: 'Superhuman Go',
        href: '/products/go-ai-assistant',
      },
      {
        label: 'Grammarly',
        href: '/products/grammarly',
      },
      {
        label: 'Coda',
        href: '/products/coda',
      },
      {
        label: 'Superhuman Mail',
        href: config.paths.mail.landing,
      },
      {
        label: 'Agent Store',
        href: config.paths.agentStore.external,
      },
    ],
  },
  {
    label: 'Company',
    links: [
      {
        label: 'Contact Us',
        href: '/contact',
      },
      {
        label: 'Help Center',
        href: '/support',
      },
      {
        label: 'Careers',
        href: 'https://job-boards.greenhouse.io/grammarly',
        openIn: 'newTab',
      },
      {
        label: 'Partners',
        href: 'https://superhuman.com/partners',
      },
    ],
  },
  {
    label: 'Legal',
    links: [
      {
        label: 'Terms',
        href: '/legal/terms',
      },
      {
        label: 'Privacy Policy',
        href: 'https://www.grammarly.com/privacy-policy',
        openIn: 'newTab',
      },
      {
        label: 'Trust',
        href: '/legal/trust',
      },
      {
        label: 'Customer Business Agreement',
        href: '/legal/terms/customer-business-agreement',
      },
    ],
  },
  {
    label: 'Connect',
    links: [
      {
        label: 'LinkedIn',
        href: 'https://www.linkedin.com/company/superhumanhq',
        icon: IconSprites.LinkedIn,
      },
      {
        label: 'X',
        href: 'https://x.com/Superhuman',
        icon: IconSprites.X,
      },
      {
        label: 'TikTok',
        href: 'https://www.tiktok.com/@superhumanhq?lang=e',
        icon: IconSprites.TikTok,
      },
      {
        label: 'Instagram',
        href: 'https://www.instagram.com/superhuman__hq/?hl=en',
        icon: IconSprites.Instagram,
      },
      {
        label: 'Threads',
        href: 'https://www.threads.com/@superhuman__hq',
        icon: IconSprites.Threads,
      },
      {
        label: 'Facebook',
        href: 'https://www.facebook.com/SuperhumanCo',
        icon: IconSprites.Facebook,
      },
    ],
  },
]
